import React from "react";
import { Mail } from "lucide-react";
import Layout from "../components/Layout";
import useSeo from "../hooks/useSeo";

const Wrap = ({ title, seoTitle, seoDesc, children }) => {
  useSeo(seoTitle, seoDesc);
  return (
  <Layout>
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-[#1f2a37] mb-5">{title}</h1>
      <div className="text-[#374151] leading-relaxed space-y-4">{children}</div>
    </div>
  </Layout>
  );
};

export const About = () => (
  <Wrap
    title="About Us"
    seoTitle="About | Morning Sunday Teer"
    seoDesc="About Morning Sunday Teer — an informational website for Shillong Morning Teer Result, previous results, common number and dream number updates."
  >
    <p>
      Morning Sunday Teer is an informational website providing Shillong Morning
      Teer Results, Previous Results, Common Numbers, Dream Numbers, Target
      Numbers, House Ending Numbers and Morning Teer Calendar.
    </p>
    <p>
      Our goal is to provide fast, accurate and mobile-friendly Morning Teer
      information for visitors. This website focuses specifically on the{" "}
      <b>Morning Teer</b> session held on Sunday mornings in Shillong, Meghalaya.
    </p>
  </Wrap>
);

export const Contact = () => (
  <Wrap
    title="Contact Us"
    seoTitle="Contact | Morning Sunday Teer"
    seoDesc="Contact Morning Sunday Teer for questions, corrections or enquiries about the Shillong Morning Teer Result."
  >
    <p>
      For any questions, corrections or business enquiries regarding{" "}
      <b>Morning Teer</b>, please contact us by email.
    </p>
    <a
      href="mailto:support@morningsundayteerresult.com"
      className="inline-flex items-center gap-2 text-[#2f5d84] font-medium hover:underline"
    >
      <Mail className="w-5 h-5" />
      support@morningsundayteerresult.com
    </a>
  </Wrap>
);

export const Privacy = () => (
  <Wrap
    title="Privacy Policy"
    seoTitle="Privacy Policy | Morning Sunday Teer"
    seoDesc="Privacy Policy of Morning Sunday Teer explaining how visitor information is handled on this informational website."
  >
    <p>
      We respect your privacy. We do not collect personal information unless
      voluntarily provided by you.
    </p>
    <p>
      We do not sell or share your personal information with third parties. This
      policy applies to all Morning Teer information pages on this website.
    </p>
  </Wrap>
);

export const Terms = () => (
  <Wrap
    title="Terms & Conditions"
    seoTitle="Terms & Conditions | Morning Sunday Teer"
    seoDesc="Terms and Conditions for using Morning Sunday Teer, an informational Shillong Morning Teer Result website."
  >
    <p>
      The information published on this website is provided for informational
      purposes only regarding <b>Morning Teer</b>.
    </p>
    <p>
      Users are responsible for their own decisions. We do not guarantee the
      accuracy or completeness of any information published on this website.
    </p>
  </Wrap>
);
